import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7b91f334 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _76f332ad = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _dc239596 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _ee1a309e = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _727dc526 = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _33125ab5 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _b9a33030 = () => interopDefault(import('..\\pages\\thank-you.vue' /* webpackChunkName: "pages_thank-you" */))
const _648cefc8 = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _b086c9dc = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _277e1a56 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _2761eb54 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _27298d50 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _270d5e4e = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _21272e16 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _501cb35e = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _5eb0226b = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _c9b8056c = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _a8295496 = () => interopDefault(import('..\\pages\\need-a-card\\patient-information.vue' /* webpackChunkName: "pages_need-a-card_patient-information" */))
const _77d7f143 = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _9f4e5cb2 = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _f059ad58 = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _9578cb28 = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _37cbd4fe = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _7b91f334,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _76f332ad,
    children: [{
      path: "",
      component: _dc239596,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _ee1a309e,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _727dc526,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _33125ab5,
    name: "rejection"
  }, {
    path: "/thank-you",
    component: _b9a33030,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _648cefc8,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _b086c9dc,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _277e1a56,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _2761eb54,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _27298d50,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _270d5e4e,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _21272e16,
    name: "errors-500"
  }, {
    path: "/need-a-card/eligibility",
    component: _501cb35e,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _5eb0226b,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _c9b8056c,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/patient-information",
    component: _a8295496,
    name: "need-a-card-patient-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _77d7f143,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _9f4e5cb2,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _f059ad58,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _9578cb28,
    name: "patient-patientSearch"
  }, {
    path: "/",
    component: _37cbd4fe,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
